<div class="row">
    <div class="col-8">
        <rask-input label="Namn"
            class="w-100"
            [maxlength]="arbetsorderNamnMaxLength"
            [(ngModel)]="arbetsorder.namn"
            (change)="arbetsorderNamnUpdated()"
            [disabled]="!isDetailEditable()"
            [rule]="validationContext.current.arbetsordernamn"></rask-input>
    </div>
    <div class="col-4">
        <rask-textmultiline label="LKD">
            <div>{{arbetsorder.lkd}}</div>
        </rask-textmultiline>
    </div>
</div>
<div class="row mt-3">
    <div class="col-4">
        @if (isSchemalagd()) {
        <rask-textmultiline label="Länk till Prolog">
            <a href="{{prologLink()}}" target="_blank">
                {{arbetsorder.beteckning}}</a>
        </rask-textmultiline>
        }
    </div>
    <div class="col-8">
        <rask-textmultiline
            label="Hämtplats"
            class="w-100">
            <div>{{arbetsorder.hamtplats}}</div>
        </rask-textmultiline>
    </div>
</div>
<div class="row">
    @if (isImport()) {
    <div class="col-8">
        <rask-textmultiline
            label="Leverantör"
            class="w-100">
            <div>{{arbetsorder.ckLeverantor}}</div>
        </rask-textmultiline>
    </div>
    }
</div>
@if (isAvgangsmatning()) {
<div class="row">
    <div class="col-6">
        <rask-textmultiline
            label="Kund"
            class="w-100">
            <div>{{arbetsorder.kund}}</div>
        </rask-textmultiline>
    </div>
    <div class="col-6">
        <rask-textmultiline
            label="Avgångshamn"
            class="w-100">
            <div>{{arbetsorder.avgangshamn}}</div>
        </rask-textmultiline>
    </div>
</div>
}
<div class="row">
    @if (uppdragsLista) {
    <div class="col-4">
        <rask-selector
            label="Uppdrag"
            [values]="uppdragsLista"
            [disabled]="!isDetailEditable()"
            [reverseLookup]="true"
            [ngModel]="arbetsorder.uppdragId"
            [formatter]="uppdragFormatter"
            [viewSelectedFormatter]="uppdragSelectedFormatter"
            placeholder="Välj uppdrag"
            [viewFormatter]="uppdragViewFormatter"
            (ngModelChange)="arbetsorderUppdragUpdated($event)"
            [addModelValueWhenMissing]="getUppdragInitialValue"
            infoText="För Viol3 används uppdrag endast internt på Sveaskog. Om du har behov av andra koder vid extraordinär händelse, kontakta förvaltningen.">
        </rask-selector>
    </div>
    }
    <div class="col-4">
    </div>
    <div class="col-4">
        <rask-textmultiline label="VIOL3-Status">
            <rask-viol3status-indicator
                [arbetsorderid]="arbetsorder.id">
            </rask-viol3status-indicator>
        </rask-textmultiline>
    </div>
</div>
@if (isSjotransport()) {
<div class="row">
    <div class="col-4">
        <rask-input
            label="Båt-id"
            [(ngModel)]="arbetsorder.batId"
            (change)="batIdUpdated()"
            [disabled]="!isDetailEditableAfterSend()"
            [maxlength]="6"
            [rule]="validationContext.current.batId"></rask-input>
    </div>
    <div class="col-4">
        <rask-checkbox
            label="Avgångsmätning"
            [(ngModel)]="arbetsorder.avgangsmatning"
            [fillHeight]="true"
            [disabled]="true"></rask-checkbox>
    </div>
</div>
}
<div class="row mt-3">
    <div class="col-5">
        <rask-selector
            label="Ansvarig för avverkning"
            [disabled]="!isDetailEditable()"
            aid="ansvarigAvverkningsledare"
            [debounceTime]="300"
            [minCharacters]="3"
            [reverseLookup]="false"
            [ngModel]="avverkningsAnsvarig"
            (ngModelChange)="selectedAvverkningsledare($event)"
            [formatter]="ansvarigFormatter"
            [viewSelectedFormatter]="ansvarigSelectedFormatter"
            placeholder="Ange minst tre tecken"
            [search]="searchForAnsvarigAvverningsledareTypeAhead"
            [viewFormatter]="ansvarigViewFormatter">
        </rask-selector>
    </div>
    <div class="col-2">
    </div>
    @if (canAvslutaVirkesorder()) {
    <div class="col-5">
        <rask-avsluta-virkesorder-button
            [arbetsorder]="arbetsorder">
        </rask-avsluta-virkesorder-button>
    </div>
    }
    @if (canAvslutaViol3Avtalsobjekt()) {
    <div class="col-5">
        <rask-arbetsorder-viol3-makulera-button
            [arbetsorder]="arbetsorder">
        </rask-arbetsorder-viol3-makulera-button>
    </div>
    }
</div>

<div class="row mt-3">
    <div class="col-5 offset-md-7">
        <rask-button id="avslutabtn" color="secondary" (click)="avslutaArbetsorder()"
            [disabled]="!canAvslutaArbetsorder()">Avsluta arbetsorder</rask-button>
    </div>
</div>
<div class="row">
    <rask-checkbox class="col-3" text="FSC" label="Certifikat" [(ngModel)]="arbetsorder.fscCertifikat"
        (ngModelChange)="setCertifikat($event)"></rask-checkbox>
    <rask-checkbox class="col-3" text="PEFC" [(ngModel)]="arbetsorder.pefcCertifikat"
        (ngModelChange)="setCertifikat($event)"></rask-checkbox>
</div>